import React from "react";
import { IconExpandMore } from "../../assets/icons";
import CommonUtil from "../../utils/CommonUtil";

const SelectSingleComponent = ({
  options,
  selectedOption,
  onChange,
  className,
}) => {
  return (
    <div className="relative inline-block min-w-28">
      <select
        value={selectedOption}
        onChange={(e) => onChange?.(e.target.value)}
        className={CommonUtil.groupClass(
          "block w-full px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm appearance-none pr-10 focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500",
          className
        )}
      >
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {/* Icon nằm ở đây */}
      <div className="absolute inset-y-0 right-2 flex items-center pointer-events-none">
        <IconExpandMore className="fill-[#9F9F9F]" />
      </div>
    </div>
  );
};

export default SelectSingleComponent;
